module.exports = "/_next/static/images/6b816797351fc6b6c57d89be14ba5164-boy-looking-to-the-front-xs@2x.jpg";